export default function AppComponentsRenderer(data, props, context) {
  const {
    value
  } = data;
  const {
    style
  } = props;
  const {
    renderer
  } = context;
  let nValue = value;
  let str;
  if (typeof nValue === 'string') {
    try {
      nValue = JSON.parse(nValue);
    } catch (err) {
      // ignore
    }
  }
  if (Array.isArray(nValue)) {
    const arr = nValue?.map(({
      type,
      version
    }) => `${type}:${version}`);
    str = arr.join(',');
  } else {
    str = null;
  }
  if (renderer.renderCell) {
    return renderer.renderCell({
      ...data,
      value: str
    }, this.props, context);
  }
  return renderer.getValueComponent([str], style);
}